var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 26",
    style: {
      enableBackground: "new 0 0 25 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3,21.9c-0.4,0-0.7-0.2-1-0.4l-6.7-7C0,13.9,0,13,0.6,12.4s1.5-0.6,2,0l5.7,5.9L21.6,4.5c0.6-0.6,1.5-0.6,2,0 c0.6,0.6,0.6,1.5,0,2.1L9.3,21.5C9,21.8,8.7,21.9,8.3,21.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCheck);
export default __webpack_public_path__ + "static/media/ico-check.4dcbe50983784266706e13dc1a58580c.svg";
export { ForwardRef as ReactComponent };